// extracted by mini-css-extract-plugin
export default {"container":"shorter-wait-time-message__container___3usNs"};